import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fc2a4d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "audit-info" }
const _hoisted_2 = { class: "audit-name" }
const _hoisted_3 = { class: "audit-date" }
const _hoisted_4 = { class: "audit-name" }
const _hoisted_5 = { class: "audit-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode === 'modified' && _ctx.item.ModifiedDate)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.getModifiedBy()), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formatDate(_ctx.item.ModifiedDate)), 1)
        ], 64))
      : (_ctx.mode === 'created' && _ctx.item.CreatedDate)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getCreatedBy()), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formatDate(_ctx.item.CreatedDate)), 1)
          ], 64))
        : _createCommentVNode("", true)
  ]))
}